/** The customer-facing name of a booking type wherever no manifest label is at hand. */
export const BOOKING_TYPE_LABEL = {
    VERDIVURDERING: "Verdivurdering",
    SALG: "Salg",
    ANALYSE: "Analyse",
};
